<template>
  <ui-dialog show max-width="542px" @input="$emit('close')">
    <template #header>
      <h3>{{ $t("message.asyncCSVExport.title") }}</h3>
    </template>
    <div class="content">
      <div>{{ $t("message.asyncCSVExport.content1") }}</div>
      <div>{{ $t("message.asyncCSVExport.content2") }}</div>
    </div>
    <template #actions>
      <ui-button color="primary" outlined @click="$emit('close')">
        {{ $t("message.asyncCSVExport.closeWindow") }}
      </ui-button>
      <ui-button color="primary" :disabled="isGenerating" @click="downloadFile">
        {{ downloadButtonText }}
        <Loader v-if="isGenerating" />
      </ui-button>
    </template>
  </ui-dialog>
</template>

<script>
const AsyncExportStatus = {
  WAITING_FOR_EXECUTION: 1,
  FAILED: 2,
  SCHEDULED: 3,
  CREATED: 4,
  SENT: 5,
  ERROR: 6,
  OTHER: 7
};

const STATUS_FETCH_INTERVAL_TIME = 3000;
import serviceHandler from "@/helpers/handlers/service";
import reportExportService from "@/services/report-export";
import FileExporter from "@/utils/file-exporter";

export default {
  name: "AsyncDownloadDialog",
  components: {
    Loader: () => import("@/components/AsyncDownloadDialog/loader.vue")
  },
  props: {
    exportId: {
      type: [String, null]
    }
  },
  data() {
    return {
      isGenerating: true,
      checkStatusInterval: null
    };
  },
  computed: {
    downloadButtonText() {
      return this.isGenerating
        ? this.$t("message.asyncCSVExport.generatingInProgress")
        : this.$t("message.asyncCSVExport.download");
    }
  },
  async created() {
    this.checkStatusInterval = setInterval(
      await this.checkStatusIntervalHandler,
      STATUS_FETCH_INTERVAL_TIME
    );
  },
  beforeDestroy() {
    clearInterval(this.checkStatusInterval);
  },
  methods: {
    async checkStatusIntervalHandler() {
      const { status } = await this.checkFileStatusMethod();
      if (
        status === AsyncExportStatus.CREATED ||
        status === AsyncExportStatus.ERROR ||
        status === AsyncExportStatus.FAILED
      ) {
        this.isGenerating = false;
        clearInterval(this.checkStatusInterval);
      }
      if (
        status === AsyncExportStatus.ERROR ||
        status === AsyncExportStatus.FAILED
      ) {
        this.$emit("close");
        this.$notify({
          group: "default",
          type: "error",
          text: this.$t("message.asyncCSVExport.fileGeneratingError")
        });
      }
    },

    checkFileStatusMethod() {
      return serviceHandler(
        reportExportService.getReportExportStatus(this.exportId)
      );
    },

    async downloadFile() {
      await new FileExporter().exportFile(() =>
        reportExportService.getReportExportDownload(this.exportId)
      );

      this.$emit("close");
      this.$notify({
        group: "default",
        type: "success",
        text: this.$t("message.common.downloadStarted")
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.content {
  color: $gray-dark;
  @include font-size(16px);
  font-weight: 500;
  margin-bottom: $spacing * 2.5;

  & > * + * {
    margin-top: $spacing * 2;
  }
}
</style>
